<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
      <path d="m8 7-4 4.5L8 16M16 7l4 4.5-4 4.5M10.5 17.5 14 5" />
    </g>
  </svg>
</template>
